import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const root = document.getElementById("root");
createRoot(root).render(
  <React.StrictMode>
    <NuqsAdapter>
      <ChakraProvider>
        <Router>
          <Provider store={store}>
            <App />
          </Provider>
        </Router>
      </ChakraProvider>
    </NuqsAdapter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
